<template>
    <div class="content">
      <div class="container-fluid">
        
        <div class="row d-flex justify-content-center">
          <div class="col-xl-2 col-md-6 uk-card">
              <stats-card
                align="center"
                style="border-radius: 16px 16px 16px 16px"
              >
                <div slot="footer">
                  <h2 class="card-title" style="font-weight:bold; color:#cc2329">
                    {{ countCmdAtteteTropLongue.length }}
                  </h2>
                  <span style="font-size:1.2em; color:black"
                    >Attente <br/> trop longue
                  </span>
                </div>
              </stats-card>
          </div>
          <div class="col-xl-2 col-md-6">
              <stats-card
                align="center"
                style="border-radius: 16px 16px 16px 16px"
              >
                <div slot="footer">
                  <h2 class="card-title" style="font-weight:bold; color:#cc2329">
                    {{ countChangeAvis.length }}
                  </h2>
                  <span style="font-size:1.2em; color:black"
                    >J'ai changé <br/> d'avis</span
                  >
                </div>
              </stats-card>
          </div>

          <div class="col-xl-2 col-md-6">
              <stats-card
                align="center"
                style="border-radius: 16px 16px 16px 16px"
              >
                <div slot="footer">
                  <h2 class="card-title" style="font-weight:bold; color:#cc2329">
                    {{ countImpossbileContacterLivreur.length }}
                  </h2>
                  <span style="font-size:1.2em; color:black"
                    >Impossbile de <br>contacter le livreur</span>
                </div>
              </stats-card>
          </div>

          <div class="col-xl-2 col-md-6">
              <stats-card
                align="center"
                style="border-radius: 16px 16px 16px 16px"
              >
                <div slot="footer">
                  <h2 class="card-title" style="font-weight:bold; color:#cc2329">
                    {{ countLivreurImpoli.length }}
                  </h2>
                  <span style="font-size:1.2em; color:black"
                    >Le livreur <br/> impoli</span>
                </div>
              </stats-card>
          </div>

          <div class="col-xl-2 col-md-6">
              <stats-card
                align="center"
                style="border-radius: 16px 16px 16px 16px"
              >
                <div slot="footer">
                  <h2 class="card-title" style="font-weight:bold; color:#cc2329">
                    {{ countLivreursNoBouge.length }}
                  </h2>
                  <span style="font-size:1.2em; color:black"
                    >Le livreur <br/> n'a pas bougé</span>
                </div>
              </stats-card>
          </div>

          <div class="col-xl-2 col-md-6">
              <stats-card
                align="center"
                style="border-radius: 16px 16px 16px 16px"
              >
                <div slot="footer">
                  <h2 class="card-title" style="font-weight:bold; color:#cc2329">
                    {{ countLivraisonsTest.length }}
                  </h2>
                  <span style="font-size:1.2em; color:black"
                    >C'était <br/> juste un test</span>
                </div>
              </stats-card>
          </div>

        </div>
        
        <div class="row">
          <div class="col-12">
            <card
              class="strpied-tabled-with-hover"
              body-classes="table-full-width table-responsive"
            >
              <template slot="header">
                <div class="uk-flex uk-flex-between uk-align-center">
                  <h4 class="card-title" style="font-weight: bold">
                    Liste des commandes annulées
                  </h4>
                </div>
              </template>
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col" class="title-tab">#</th>
                    <th scope="col" class="tilte-tab">Commentaire</th>
                    <th scope="col" class="tilte-tab">Motif</th>
                    <th scope="col" class="tilte-tab">Date et heure</th>
                    <th scope="col" class="tilte-tab">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(cmd, itemObjKey) in CmdCancel"
                    class="livraison"
                    uk-scrollspy="target: > td; cls:  uk-animation-slide-bottom-small; delay: 150"
                  >
                    <td>{{ itemObjKey + 1 }}</td>
                    <td>{{ cmd.commentaire }}</td>
                    <td>{{ cmd.reponse }}</td>
                    <td>
                      {{
                        formatDate(cmd.created_at) +
                        " à " +
                        formatHeure(cmd.created_at)
                      }}
                    </td>
                    <td>
                      <button
                        v-if="getRole == 5"
                        @click="removeColis(cmd.id)"
                        class="btn btn-default uk-box-shadow-large"
                      >
                        <span
                          class=""
                          style="color: #5f5f5f"
                          uk-icon="icon:trash; ratio: 1"
                        ></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </card>
          </div>
        </div>

      </div>
    </div>
  </template>
  
  <script>
  import { db } from "../../main";
  
  export default {
    name: "Commandes Annulées",
    data() {
      return {
        date_created: new Date,
        CmdCancel: [],
        count: [],
        access: 0,
        user: {},
        getRole :0,
        role:"",
        countCmdAtteteTropLongue: [],
        countChangeAvis: [],
        countImpossbileContacterLivreur: [],
        countLivreurImpoli: [],
        countLivraisonsTest: [],
        countLivreursNoBouge: [],
        
      };
    },
  
    methods: {
      validDate() {
        let dbRef = db.ref("ReponsesAnnulations")
        dbRef.get()
        .then((childSnapshot) => {
          const childData = childSnapshot.val();
          this.CmdCancel = childData;
        })
        .catch((error) => {
          console.log(error);
        });
        db.ref("ReponsesAnnulations")
        .orderByChild("created_at")
        .startAt(this.date_created)
        .once("value")
        .then((dataSnapshot) => {
          dataSnapshot.forEach((childSnapshot) => {
            this.colisDuJour.push(childSnapshot.val())
          });
            this.show = true;
        });
      },
      currentDateTime() {
        const current = new Date();
        const date =
          current.getDate() +
          " - 0" +
          (current.getMonth() + 1) +
          " - " +
          current.getFullYear();
        const dateTime = date;
        return dateTime;
      },
      formatDate(date) {
        const options = { year: "numeric", month: "long", day: "numeric" };
        return new Date(date).toLocaleDateString("fr", options);
      },
      formatHeure(date) {
        const options = { hour: "numeric", minute: "numeric", second: "numeric" };
        return new Date(date).toLocaleString("fr", options);
      },
      removeColis(key) {
        if (this.access == 5) {
          db.ref("ReponsesAnnulations").child(key).remove();
        }
      },
    },
  
    created() {
      this.getRole =  this.$store.getters.user.data.role;
      if(this.getRole == 0){
         this.role = 'client'
      } else if(this.getRole == 1){
         this.role = 'livreur'
      } else if(this.getRole == 2){
         this.role = 'commercial'
      } else if(this.getRole == 3){
         this.role = 'superviseur'
      } else if(this.getRole == 4){
         this.role = 'logisticien'
      } else if(this.getRole == 5){
         this.role = 'administrateur'
      }

      //Recupération Attente trop longue
      db.ref("ReponsesAnnulations").orderByChild("reponse").equalTo("Attente trop longue").once("value", (dataSnapshot) => {
          const itemsArray = [];
        dataSnapshot.forEach((childSnapshot) => {
          itemsArray.push({});
          this.countCmdAtteteTropLongue = itemsArray;
        });
      });

      db.ref("ReponsesAnnulations").orderByChild("reponse").equalTo("J'ai changé d'avis").once("value", (dataSnapshot) => {
          const itemsArray = [];
        dataSnapshot.forEach((childSnapshot) => {
          itemsArray.push({});
          this.countChangeAvis = itemsArray;
        });
      });

      
      db.ref("ReponsesAnnulations").orderByChild("reponse").equalTo("Impossbile de contacter le livreur").once("value", (dataSnapshot) => {
          const itemsArray = [];
        dataSnapshot.forEach((childSnapshot) => {
          itemsArray.push({});
          this.countImpossbileContacterLivreur = itemsArray;
        });
      });

      db.ref("ReponsesAnnulations").orderByChild("reponse").equalTo("Le livreur est impoli").once("value", (dataSnapshot) => {
          const itemsArray = [];
        dataSnapshot.forEach((childSnapshot) => {
          itemsArray.push({});
          this.countLivreurImpoli = itemsArray;
        });
      });

      db.ref("ReponsesAnnulations").orderByChild("reponse").equalTo("Le livreur n'a pas bougé").once("value", (dataSnapshot) => {
          const itemsArray = [];
        dataSnapshot.forEach((childSnapshot) => {
          itemsArray.push({});
          this.countLivreursNoBouge = itemsArray;
        });
      });

      db.ref("ReponsesAnnulations").orderByChild("reponse").equalTo("C'était juste un test").once("value", (dataSnapshot) => {
          const itemsArray = [];
        dataSnapshot.forEach((childSnapshot) => {
          itemsArray.push({});
          this.countLivraisonsTest = itemsArray;
        });
      });
    
      this.access = this.$store.getters.user.data.role;
      const dfRef = db.ref("ReponsesAnnulations");
        dfRef
        .on("value", (dataSnapshot) => {
          const itemsArray = [];
          dataSnapshot.forEach((childSnapshot) => {
            const childData = childSnapshot.val();
            const childDataKey = childSnapshot.key;
            this.cancel = childData;
            itemsArray.push({
              id: childDataKey,
              client_id: childData.client_id,
              commentaire: childData.commentaire,
              reponse: childData.reponse,
              created_at: childData.created_at,
            });
          });
          this.CmdCancel = itemsArray.reverse();
        });
    },
  };
  </script>
  
  <style>
  .tilte-tab {
    color: #000000 !important;
    font-weight: bold !important;
    font-size: 0.9em !important;
    font-family: "Poppins", sans-serif !important;
  }
  .livraison {
    font-weight: bold !important;
  }
  td {
    font-family: "Poppins", sans-serif !important;
    font-size: 0.9em !important;
  }
  .btn-primary {
    margin-right: 12px;
  }
  .dateToday {
    padding: 10px;
    border-radius: 20px;
    color: #ffffff !important;
  }
  .uk-form-width-small {
    background-color: #5dd381 !important;
    color: #ffffff !important;
    font-weight: bold !important;
    font-size: 0.9em !important;
    outline: none;
    border-radius: 10px;
    border: none;
  }
  .uk-label {
    font-size: 0.9em !important;
    font-weight: bold !important;
  }
  .uk-label:hover {
    background-color: #1f5cdf !important;
  }
  .uk-label:active {
    background-color: #0c307e !important;
  }
  </style>
  
  